<template>
    <div class="dataStatisticPage">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="宿州市市县区、园区PM2.5考核统计表" name="first">
                <div class="time">
                    <el-date-picker
                            size="mini"
                            v-model="queryParam.time"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            placeholder="选择日期时间">
                    </el-date-picker>
                    <a-button size="small" type="primary" @click="getAllList">查询</a-button>
                </div>
                <div class="title">
                    宿州市市县区、园区PM<sub>2.5</sub>考核统计表
                </div>
                <table class="table_d" width="80%" cellpadding="0" cellspacing="0"
                       style="border-color: #eee;" v-if="allListData.list && allListData.list.length">
                    <thead class="tr_th4_td4">
                    <tr>
                        <th rowspan="2">市县</th>
                        <th rowspan="2">站点</th>
                        <th colspan="4">PM<sub>2.5</sub> (微克/立方米)</th>
                    </tr>
                    <tr>
                        <th>{{allListData.day}}</th>
                        <th>{{allListData.day}}</th>
                        <th>{{allListData.month}}</th>
                        <th>{{allListData.month}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in allListData.list" :key="index"
                        :class="{backColor :item.indexs%2===0}">
                        <td :rowspan="item.rowspan" v-if="item.rowspan">{{item.belongConty}}</td>
                        <td>{{item.changgeName}}</td>
                        <td :rowspan="item.rowspan" v-if="item.rowspan">{{item.dayAvg}}</td>
                        <td>{{item.day}}</td>
                        <td :rowspan="item.rowspan" v-if="item.rowspan">{{item.monthAvg}}</td>
                        <td>{{item.month}}</td>
                    </tr>
                    </tbody>
                </table>
                <div v-else style="text-align: center;margin: 20px">暂无数据</div>

            </el-tab-pane>
            <el-tab-pane label="宿州市乡镇站点空气质量一览表" name="second">
                <div class="time">
                    <el-date-picker
                            size="mini"
                            v-model="queryParam.time"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            placeholder="选择日期时间">
                    </el-date-picker>
                    <a-button size="small" type="primary" @click="getTownList">查询</a-button>
                </div>
                <div class="title">
                    宿州市乡镇站点空气质量一览表
                </div>
                <table class="table_d" width="80%" cellpadding="0" cellspacing="0"
                       style="border-color: #eee;" v-if="airTownListData.list &&airTownListData.list.length">
                    <thead class="tr_th4_td4">
                    <tr>
                        <th rowspan="2">序号</th>
                        <th rowspan="2">区县</th>
                        <th rowspan="2">站点</th>
                        <th colspan="2">PM<sub>2.5</sub> (微克/立方米)</th>
                    </tr>
                    <tr>
                        <th>{{airTownListData.day}}</th>
                        <th>{{airTownListData.month}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in airTownListData.list" :key="index"
                        :class="{backColor :item.indexs%2===0}">
                        <td>{{index+1}}</td>
                        <td :rowspan="item.rowspan" v-if="item.rowspan">{{item.belongConty}}</td>
                        <td>{{item.stationName}}</td>
                        <td>{{item.day}}</td>
                        <td>{{item.month}}</td>
                    </tr>
                    </tbody>
                </table>
                <div v-else style="text-align: center;margin: 20px">暂无数据</div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import url from "../utils/UrlApi"

    export default {
        name: "dataStatistic",
        data() {
            return {
                queryParam: {
                    time: ''
                },
                allListData: {},
                airTownListData: {},
                activeName: 'first'
            }
        },
        mounted() {
            this.getAllList()
            this.getTownList()
        },
        methods: {
            getAllList() {
                let data = this.queryParam
                this.$http.get(url.airAllList, {
                    params: data
                }).then(res => {
                    // console.log(res)
                    if (res.data.code === '200') {
                        console.log(res)
                        let data = res.data.data
                        let index = 0

                        for (let i = 0; i < data.list.length; i++) {
                            if (i !== 0) {
                                if (data.list[i].belongConty !== data.list[i - 1].belongConty) {
                                    index++
                                }
                            }
                            data.list[i].indexs = index
                        }

                        this.allListData = data
                    } else {
                        this.$message.error(res.data.message)
                    }

                })
            },

            getTownList() {
                let data = this.queryParam
                this.$http.get(url.airTownList, {
                    params: data
                }).then(res => {
                    // console.log(res)
                    if (res.data.code === '200') {
                        console.log(res)
                        let data = res.data.data
                        let index = 0

                        for (let i = 0; i < data.list.length; i++) {
                            if (i !== 0) {
                                if (data.list[i].belongConty !== data.list[i - 1].belongConty) {
                                    index++
                                }
                            }
                            data.list[i].indexs = index
                        }

                        this.airTownListData = data
                    } else {
                        this.$message.error(res.data.message)
                    }

                })
            },
            handleClick(tab, event) {
                console.log(tab, event);
            }
        }
    }
</script>

<style scoped lang="less">
    .dataStatisticPage {
        padding-bottom: 20px;
        min-height: 100%;
        /*height: 100%;*/
    }

    .table_d {
        border: 1px solid #171d1a;
        /*border-width: 1px 1px 1px 1px;*/
        text-align: center;
        margin: 8px auto;
        padding: 4px;
        th {
            text-align: center;
            width: 16.66%;
            border: solid #171d1a;
            border-width: 1px 1px 1px 1px;
            padding: 10px 0px;
            font-size: 22px;
            font-weight: bold;
        }
        td {
            border: solid #171d1a;
            border-width: 1px 1px 1px 1px;
            padding: 10px 0;
            font-size: 22px;
            font-weight: bold;
        }
        tbody {
            tr {
                text-align: center;
                /*background-color: rgba(255, 219, 94, 0.1);*/
                background: #fff;
            }
            .backColor {
                background-color: #bfd9e1;
            }
        }
    }

    .title {
        text-align: center;
        font-size: 24px;
        /*margin: 16px 0;*/
        font-weight: bold;
    }

    .time {
        padding: 6px 20px;
        /*float: right;*/
        z-index: 88;
        position: absolute;
        right: 6px;
    }
</style>